import './index.css';

import * as React from 'react';
import type { GliderMethods } from 'react-glider';
import Glider from 'react-glider';

import Video1 from '@/assets/collaborate.webm';
import Video3 from '@/assets/never-miss-an-update.webm';
import Video2 from '@/assets/organize-daily-feeds.webm';
import { Text } from '@/atoms/Text/Text';

import { VideoViewer } from './VideoViewer';

const VideoList = [
  { src: Video1, label: 'All your information in one place' },
  { src: Video2, label: 'Organize your daily information consumption' },
  { src: Video3, label: 'Centralize collaboration with peers' },
];

export const Slider = () => {
  const gliderRef = React.useRef<GliderMethods>(null);
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);

  const playNext = () => {
    if (!gliderRef.current) {
      throw new Error('Glider ref is not defined.');
    }

    const nextIndex =
      currentIndex < VideoList.length - 1 ? currentIndex + 1 : 0;
    setCurrentIndex(nextIndex);

    gliderRef.current.scrollItem(nextIndex);
  };

  const onSlideChange = (event: CustomEvent) => {
    setCurrentIndex(event.detail.slide);
  };

  return (
    <div className='w-full flex flex-col items-center gap-4'>
      <Text bold size='lg' color='gray'>
        {VideoList[currentIndex].label}
      </Text>
      <div className='w-1/2 self-center '>
        <Glider
          ref={gliderRef}
          hasDots
          slidesToShow={1}
          onSlideVisible={onSlideChange}
        >
          {VideoList.map(({ src: videoSrc }, index) => (
            <VideoViewer
              key={index}
              src={videoSrc}
              playNext={playNext}
              startPlay={index === currentIndex}
            />
          ))}
        </Glider>
      </div>
    </div>
  );
};
